import { render } from "./CardTransactions.vue?vue&type=template&id=0a63f154&scoped=true"
import script from "./CardTransactions.vue?vue&type=script&lang=js"
export * from "./CardTransactions.vue?vue&type=script&lang=js"

import "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=0a63f154&scoped=true&lang=css&external"
import "./CardTransactions.vue?vue&type=style&index=1&id=0a63f154&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a63f154"]])

export default __exports__